<template>
  <div>
    <div class="box" style="width: 100%">
      <div>
        <h1 class="title is-5" style="padding-bottom: 0.5rem">Roles</h1>
        <p class="subtitle is-size-7" style="padding-bottom: 0.5rem">Selecciona los roles que quieres asignar a este usuario</p>
        <div class="columns is-multiline">
          <div
            v-for="(role, roleIndex) in roles"
            :key="roleIndex"
            class="column is-half">
            <div class="control">
              <div class="block">
                <b-switch v-model="userRolesData"
                  :native-value="role.name"
                  :disabled="viewMode">
                  {{ role.description }}
                </b-switch>
                <!--              <p-->
                <!--                class="help"-->
                <!--                v-text="role.description"-->
                <!--              />-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import RoleService from '@/services/RoleService'
export default {
  name: 'UserRoleSelect',
  props: {
    currentRoles: {
      type: Array,
      required: false,
      default: () => []
    },
    viewMode: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      roles: [],
      userRolesData: []
    }
  },
  async created () {
    await this.getRoles()
    this.userRolesData = this.currentRoles
  },
  methods: {
    async getRoles () {
      let params = {}
      this.isLoading = true
      let response = await RoleService.getRoles(params)
      this.roles = response.data.data
    }
  },
  watch: {
    userRolesData () {
      this.$emit('update:userRoles', this.userRolesData)
    },
    currentRoles () {
      this.userRolesData = this.currentRoles
    }
  }
}
</script>

<style scoped>

</style>
